import { QueryHookOptions, useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';
import { useCurrentUserProfile } from 'src/graphql/entities/platform-user';
import { UPDATE_USER_SETTING_VALUE_QUERY } from 'src/graphql/entities/user-setting-value/user-setting-value.operations';
import { UserSettingValue } from 'src/graphql/entities/user-setting-value/user-setting-value.types';
import { UserSettingValueRaw } from 'src/types';

export interface UpdateUserSettingValue {
  updateUserSettingValue: UserSettingValueRaw[];
}

export const useUpdateUserSettingValue = () => {
  const { user } = useCurrentUserProfile();
  const [updateUserSettingValue, { loading: isLoading }] = useMutation<UpdateUserSettingValue>(
    UPDATE_USER_SETTING_VALUE_QUERY,
  );

  const updateWithOptimisticResponse = useCallback(
    (
      original: UserSettingValue,
      patch: Partial<UserSettingValue>,
      onCompleted?: QueryHookOptions['onCompleted'],
    ) => {
      void updateUserSettingValue({
        variables: {
          data: patch,
          userId: user?.userId,
          userSettingId: original.userSettingId,
        },
        optimisticResponse: {
          updateUserSettingValue: [
            {
              ...(original as UserSettingValueRaw),
              ...patch,
            },
          ],
        },
        onCompleted,
        context: {
          omitIsolationModeHeader: true,
        },
      });
    },
    [updateUserSettingValue, user?.userId],
  );

  return {
    updateUserSettingValue: updateWithOptimisticResponse,
    isLoading,
  };
};
